<template>
  <Dropdown
    class="w-fit border border-darkest-gray text-wrap mb-6 md:mb-5"
    close-on-click
  >
    <template #trigger="{ toggle, isOpen }">
      <button
        class="btn normal-case w-full py-4 pl-4 pr-12 m-0 relative text-left"
        type="button"
        data-test-airport-dropdown
        @click="toggle"
      >
        <template v-if="hasSelectedAirport">
          <slot name="label">
            <strong class="h6 inline">
              {{ $t('charterDestinations.availableFrom') }}
            </strong>
            <span
              class="ml-4 h6 inline font-normal"
              data-test-airport-dropdown-value
            >{{ selectedAirport.airport_name }}</span>
          </slot>
        </template>
        <template v-else>
          <strong class="h6 inline">
            {{ $t('charterDestination.selectAirport') }}
          </strong>
        </template>
        <div class="icon-dropdown max-h-full absolute right-0 top-0 pr-4 h-full flex items-center">
          <fa
            size="lg"
            :icon="isOpen ? 'chevron-up' : 'chevron-down'"
          />
        </div>
      </button>
    </template>
    <template #content>
      <div class="w-full bg-white">
        <button
          v-for="airport in airports"
          :key="airport.airport"
          class="dropdown-item"
          type="button"
          :class="{ 'bg-orange': hasSelectedAirport && airport.airport === selectedAirport.airport }"
          @click="selectAirport(airport)"
        >
          <span>
            {{ airport.airport_name }}
          </span>
        </button>
        <button
          v-if="includeAllAirportsOption"
          class="dropdown-item"
          type="button"
          :class="{ 'bg-orange': !hasSelectedAirport }"
          @click="selectAirport({})"
        >
          {{ $t('charterDestinations.fromAllAirports') }}
        </button>
      </div>
    </template>
  </Dropdown>
</template>

<script>
import { mapActions } from 'pinia'

export default defineNuxtComponent({
  props: {
    selectedAirport: {
      type: Object,
      default: () => ({}),
    },

    airports: {
      type: Array,
      default: () => [],
    },

    isGlobal: {
      type: Boolean,
      default: true,
    },

    includeAllAirportsOption: {
      type: Boolean,
      default: true,
    },
  },

  emits: ['onSelect'],

  computed: {
    hasSelectedAirport () {
      return this.selectedAirport.airport_name
    },
  },

  methods: {
    ...mapActions(useSearchWidgetsStore, {
      setStagedAirport: 'SET_STAGED_AIRPORT',
    }),

    ...mapActions(useDealfinderStore, {
      setAirportDealfinder: 'SELECT_AIRPORT',
    }),

    ...mapActions(useRootStore, {
      setGlobalAirport: 'setSelectedAirport',
    }),

    selectAirport (airport) {
      this.$emit('onSelect', airport)

      if (this.isGlobal) {
        this.setGlobalAirport(airport.airport)
        this.setAirportDealfinder(airport)
        this.setStagedAirport(airport)
      }
    },
  },
})
</script>
